import Radio from '@/components/UI/FormElements/Radio';
import { useDispatch, useSelector } from 'react-redux';
import { FC } from 'react';

interface RootState {
  ui: {
    settings: {
      changePercentage?: string;
    };
  };
}

/**
 * Component for selecting how percentage metric changes are calculated.
 */
const MetricChangeFrom: FC = () => {
  const dispatch = useDispatch();
  const settings = useSelector((state: RootState) => state.ui.settings);

  const updateSettings = (setting: Record<string, unknown>) => {
    dispatch({ type: 'SAVE_SETTING', setting });
  };

  return (
    <div className="pa3 bb b--moon-gray">
      <PercentageChange settings={settings} updateSettings={updateSettings} />
    </div>
  );
};

interface PercentageChangeProps {
  settings: { changePercentage?: string };
  updateSettings: (setting: Record<string, unknown>) => void;
}

export const PercentageChange: FC<PercentageChangeProps> = ({ settings, updateSettings }) => {
  const options: Record<string, string> = {
    value_change_from_first: 'First taken',
    value_change: 'Last taken',
  };

  const handleClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateSettings({ ...settings, changePercentage: event.target.value });
  };

  return (
    <div className="flex items-center">
      <div className="f6 near-black lh-title mr3">% Metric change from</div>
      <div className="flex flex-wrap">
        {Object.keys(options).map((key) => (
          <div key={key} className="dib mr3">
            <Radio
              id={key}
              name="options"
              checked={settings?.changePercentage === key}
              label={options[key]}
              onChange={handleClick}
              value={key}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MetricChangeFrom;
